import { ChoiceLogo } from "@/components/common/ChoiceLogo";

/**
 * The single, professional full-screen loader for the whole app. Pixel-matches
 * the homepage first-paint loader (#app-boot-loader in index.html): navy #0B2D4D
 * backdrop, the navbar's inline Choice Wealth SVG at 80px, gently pulsing.
 *
 * CRITICAL: the layout + navy background are set with INLINE STYLES, not Tailwind
 * classes. In dev (and any FOUC window) the stylesheet applies a tick after the
 * JS runs — if the backdrop came from a Tailwind class, the loader would flash as
 * an unstyled white screen with a faint (light-on-white) logo before turning navy.
 * Inline styles + inline keyframes guarantee the correct look from the first frame
 * on every page. Every loading state routes through this component.
 */
const PULSE_KEYFRAMES = `@keyframes cw-page-loader-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}`;

export function PageLoader() {
  return (
    <div
      role="status"
      aria-label="Loading"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 120,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0B2D4D",
      }}
    >
      <style>{PULSE_KEYFRAMES}</style>
      <ChoiceLogo
        variant="light"
        style={{ height: "80px", width: "auto", animation: "cw-page-loader-pulse 1.6s ease-in-out infinite" }}
      />
      <span style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" }}>
        Loading
      </span>
    </div>
  );
}
